export default __webpack_public_path__ + "static/cruiselines-vv-ship-1-20553d3fc5cabadc1efcaf2a35c15b4b.jpg";